// extracted by mini-css-extract-plugin
module.exports = {"steps":"steps_steps__Y9lRR","step":"steps_step__PrhL0","active":"steps_active__U5tdp","mobileText":"steps_mobileText__1RWxq"};